import React from 'react';

export interface StepperIndicatorProps extends React.HTMLAttributes<HTMLDivElement> {}

function StepperIndicator({
  className = '',
  children,
  ...props
}: StepperIndicatorProps): JSX.Element {
  return (
    <div className={`stepper-indicator ${className}`} role="group" {...props}>
      {children}
    </div>
  );
}

export default StepperIndicator;
